export default __webpack_public_path__ + "static/media/bbcLogo.3b789d8a.png";